import { Component } from '@angular/core';

@Component({
  selector: 'cpb-readonly-container',
  template: ` <div class="readonly-container" [attr.data-test]="'builder-readonly'"><ng-content></ng-content></div>`,
  styleUrls: ['./readonly-container.component.scss'],
})
export class CapturumReadonlyContainerComponent {}
